import { DraggableTree } from 'vue-draggable-nested-tree'
import ChecklistItem from './checklist-item'
import AlertChecklist from '@/components/alert-checklist'
import Statistic from './statistic'
import Info from './info'
import swal from 'sweetalert'
import StatusCode from '@/status'
import lodash from 'lodash'
import { scroller } from 'vue-scrollto/src/scrollTo'
export default {
  name: 'views',
  components: {
    Tree: DraggableTree,
    ChecklistItem,
    Info,
    AlertChecklist,
    Statistic
  },
  props: [],
  data() {
    return {
      data_print: [],
      select_group: {},
      loading: false,
      showSearch: false,
      txt_search: ''
    }
  },
  watch: {
    txt_search(newSearch, old) {
      this.sss()
    }
  },
  created: function () {
    this.sss = lodash.debounce(this.search, 500)
  },
  computed: {
    data() {
      return this.$store.getters['Audit/getGroupOfChecklist']
    },
    checklist_items() {
      return this.$store.getters['Audit/getChecklistItemOfGroupChecklist']
    },
    checklist() {
      return this.$store.getters['Checklist/showChecklist']
    },
    checklist_item_status() {
      return this.$store.getters['ChecklistItemStatus/getListStatus']
    },
    checklist_users() {
      return this.$store.getters['Audit/getUserOfChecklist']
    },
    quick_reports() {
      return this.$store.getters['Audit/getQuickReport']
    },
    select_status() {
      return this.$store.getters['Audit/getSelectStatus']
    },
    complete() {
      return this.$store.getters['Audit/getComplete']
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.$loading.start()
    // this.loading = true
    this.$store.dispatch('Audit/clearSelectStatus')
    if (to.query.grp) {
      this.select_group = { id: to.query.grp }
    }
    Promise.all([
      this.$store.dispatch('Audit/getGroupOfChecklist', { checklist: { id: to.params.checklist_id }, select_status: this.select_status }),
      this.$store.dispatch('Audit/getChecklistItemOfGroupChecklist', { checklist: { id: to.params.checklist_id }, group_checklist_item: { id: to.query.grp }, select_status: this.select_status }),
      this.$store.dispatch('Checklist/showChecklist', { checklist: { id: to.params.checklist_id } }),
      this.$store.dispatch('ChecklistItemStatus/getListStatus'),
      this.$store.dispatch('Audit/getUserOfChecklist', { checklist: { id: to.params.checklist_id } }),
      this.$store.dispatch('Audit/quickReport', { checklist: { id: to.params.checklist_id } })
    ]).then(res => {
      this.$loading.complete()
      this.loading = false

      var container = document.getElementById('tree-grp');
      var idScroll = "node-" + to.query.grp;
      var offsetTop = document.getElementById(idScroll).offsetTop - 100;
      container.scrollTo({ top: offsetTop })

      next()
    }).catch(errors => {
      this.$loading.fail()
      this.loading = false
    })
  },
  mounted() {
    if (this.$route.query.grp) {
      this.select_group = { id: this.$route.query.grp }
      this.$store.dispatch('Audit/getChecklistItemOfGroupChecklist', { checklist: { id: this.$route.params.checklist_id }, group_checklist_item: { id: this.$route.query.grp }, select_status: this.select_status }).then(res => {
        this.$loading.complete()
        scroller()('#id' + this.$route.query.item)
      }).catch(errors => {
        this.$loading.fail()
      })
    }
    this.$loading.start()
    // this.loading = true
    this.$store.dispatch('Audit/clearSelectStatus')
    Promise.all([
      this.$store.dispatch('Audit/getGroupOfChecklist', { checklist: { id: this.$route.params.checklist_id }, select_status: this.select_status }),
      this.$store.dispatch('Checklist/showChecklist', { checklist: { id: this.$route.params.checklist_id } }),
      this.$store.dispatch('ChecklistItemStatus/getListStatus'),
      this.$store.dispatch('Audit/getUserOfChecklist', { checklist: { id: this.$route.params.checklist_id } }),
      this.$store.dispatch('Audit/quickReport', { checklist: { id: this.$route.params.checklist_id } })
    ]).then(res => {
      this.$loading.complete()
      this.loading = false

      var container = document.getElementById('tree-grp');
      var idScroll = "node-" + this.$route.query.grp;
      var offsetTop = document.getElementById(idScroll).offsetTop - 100;
      container.scrollTo({ top: offsetTop })

    }).catch(errors => {
      this.$loading.fail()
      this.loading = false
    })
  },
  methods: {
    select(groupChecklistItem) {
      if (this.select_group.id === groupChecklistItem.id || groupChecklistItem.total === 0) {
        return false
      }
      this.showSearch = false
      this.$refs.checklist_item.start()
      this.$store.commit('Audit/getChecklistItemOfGroupChecklist', null)
      this.select_group = groupChecklistItem
      this.$loading.start()
      this.$store.dispatch('Audit/getChecklistItemOfGroupChecklist', { checklist: { id: this.$route.params.checklist_id }, group_checklist_item: groupChecklistItem, select_status: this.select_status }).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    information() {
      this.$loading.start()
      // this.loading = true
      Promise.all([
        this.$store.dispatch('Audit/quickReport', { checklist: { id: this.$route.params.checklist_id } })
      ]).then(res => {
        this.select_group = {}
        this.$loading.complete()
        this.loading = false
      }).catch(errors => {
        this.$loading.fail()
        this.loading = false
      })
    },
    summary() {
      this.$router.push('summary')
    },
    historySummary() {
      this.$router.push('summary/history')
    },
    auditResult() {
      this.$router.push('audit-result')
    },
    statistic() {
      this.$loading.start()
      this.$store.dispatch('Audit/quickReport', { checklist: { id: this.$route.params.checklist_id } }).then(res => {
        this.$refs.statistic.show(this.quick_reports)
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    addGroupChecklistItem() {
      if (parseInt(this.checklist.status.code) !== parseInt(StatusCode.SUBMITTING)) {
        swal({
          title: this.$t('checklist.error.add_group_checklist_item.title'),
          text: this.$t('checklist.error.add_group_checklist_item.text') + this.checklist.status.name,
          icon: 'warning'
        })
      } else {
        this.$router.push('checklist-item')
      }
    },
    setStatus(status) {
      if (!status) {
        this.$store.dispatch('Audit/clearSelectStatus')
      } else {
        this.$store.dispatch('Audit/setSelectStatus', status)
      }
      this.select_group = {}
      // this.loading = true
      this.$loading.start()
      this.$store.dispatch('Audit/getGroupOfChecklist', { checklist: { id: this.$route.params.checklist_id }, select_status: this.select_status }).then(res => {
        this.$loading.complete()
        // this.loading = false
      }).catch(errors => {
        // this.loading = false
        this.$loading.fail()
      })
    },

    toggleSearch() {
      this.showSearch = !this.showSearch
    },

    search: function () {
      if (!this.txt_search) {
        return false
      }
      this.$store.commit('Audit/getChecklistItemOfGroupChecklist', null)
      this.select_group = { header: this.$t('checklist.search') + ' "' + this.txt_search + '"' }
      var vm = this
      vm.$store.dispatch('Audit/searchChecklist', { checklist: { id: vm.$route.params.checklist_id }, search: vm.txt_search }).then(res => {
        vm.checklist_items.map(item => {
          item.content = item.content.replace(new RegExp(vm.txt_search, 'gi'), '<span class="hightlighted">' + vm.txt_search + '</span>')
          item.header = item.header.replace(new RegExp(vm.txt_search, 'gi'), '<span class="hightlighted">' + vm.txt_search + '</span>')
          return item
        })
      }).catch(errors => {
      })
    },
    check(status) {
      var flag = false
      this.select_status.forEach(element => {
        if (parseInt(status.id) === parseInt(element.id)) {
          flag = true
        }
      })
      return flag
    },
    async printChecklist(checklist) {
      this.$loading.start()
      await this.$store.dispatch('Audit/getChecklistItemOfChecklist', { checklist }).then(res => {
        this.data_print = res
        console.log(this.data_print)
        this.$loading.complete()
        this.$nextTick(() => {
          var innerContents = document.getElementById('page').innerHTML
          var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
          popupWinindow.document.open()
          popupWinindow.document.write('<html><head><link rel="stylesheet" href="/static/bootstrap.css"/><link rel="stylesheet" type="text/css" href="/static/print.css" /><link rel="stylesheet" type="text/css" href="/static/style.css" /></head><body onload="window.print()">' + innerContents + '</html>')
          popupWinindow.document.close()
        })
      }).catch(errors => {
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/view.js